import React, { useState, useEffect } from 'react';
import { Layout, ConfigProvider } from 'antd';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import MobileScanPage from './components/MobileScanPage';
import ProcurementDashboard from './procurement/ProcurementDashboard';
import 'antd/dist/reset.css';
import './App.css';

const { Content } = Layout;

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [userRole, setUserRole] = useState('');
  const [loading, setLoading] = useState(true);

  const isMobileScanPage = window.location.pathname.startsWith('/scan/');

  useEffect(() => {
    if (isMobileScanPage) {
      setLoading(false);
      return;
    }

    const checkAuth = () => {
      try {
        const storedAuth = localStorage.getItem('auth');
        if (storedAuth) {
          const authData = JSON.parse(storedAuth);
          if (authData.expiry && Date.now() > authData.expiry) {
            localStorage.removeItem('auth');
            setIsAuthenticated(false);
          } else {
            setIsAuthenticated(true);
            setUsername(authData.username);
            setUserRole(authData.role);
          }
        }
      } catch (error) {
        console.error('Error reading auth from localStorage:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [isMobileScanPage]);

  const handleLogin = (username, role) => {
    setIsAuthenticated(true);
    setUsername(username);
    setUserRole(role || '');

    const authData = {
      username,
      role: role || '',
      timestamp: Date.now(),
      expiry: Date.now() + (24 * 60 * 60 * 1000),
    };
    localStorage.setItem('auth', JSON.stringify(authData));
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUsername('');
    setUserRole('');
    localStorage.removeItem('auth');
  };

  if (isMobileScanPage) {
    return (
      <ConfigProvider theme={{ token: { colorPrimary: '#1890ff' } }}>
        <MobileScanPage />
      </ConfigProvider>
    );
  }

  const renderAuthenticatedView = () => {
    // Procurement roles
    if (['procurement_user', 'procurement_accounts', 'procurement_admin'].includes(userRole)) {
      return (
        <ProcurementDashboard
          username={username}
          role={userRole}
          onLogout={handleLogout}
        />
      );
    }

    // Petty cash admin
    if (userRole === 'pettycash_admin') {
      return (
        <AdminDashboard
          username={username}
          role={userRole}
          onLogout={handleLogout}
        />
      );
    }

    // Default petty cash user
    return (
      <Dashboard
        username={username}
        role={userRole}
        onLogout={handleLogout}
      />
    );
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        height: '100vh', background: '#f4f7fa',
      }}>
        Loading...
      </div>
    );
  }

  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#1890ff' } }}>
      <Layout className="layout" style={{ minHeight: '100vh' }}>
        <Content>
          {!isAuthenticated ? (
            <Login onLogin={handleLogin} />
          ) : (
            renderAuthenticatedView()
          )}
        </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default App;